import { render } from "./RgbSquare.vue?vue&type=template&id=0c5e2f4a&scoped=true"
import script from "./RgbSquare.vue?vue&type=script&lang=js"
export * from "./RgbSquare.vue?vue&type=script&lang=js"

import "./RgbSquare.vue?vue&type=style&index=0&id=0c5e2f4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5e2f4a"]])

export default __exports__